import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"
import { showToast } from "../utils/show_toast"
import { csrfToken } from "../utils/csrf_token"

export default class extends Controller {
  static values = {
    reorderUrl: String
  }

  connect() {
    if (!this.reorderUrlValue) return

    this.sortable = Sortable.create(this.element, {
      handle: ".sortable-handle",
      animation: 150,
      ghostClass: "opacity-50",
      draggable: "[data-gallery-image-id]",
      onStart: () => { this.orderBeforeDrag = this.currentRows() },
      onEnd: () => this.persistOrder()
    })
  }

  disconnect() {
    this.sortable?.destroy()
  }

  currentRows() {
    return Array.from(this.element.querySelectorAll("[data-gallery-image-id]"))
  }

  persistOrder() {
    const rows = this.currentRows()
    const orderedIds = rows.map((row) => row.dataset.galleryImageId).filter(Boolean)

    if (orderedIds.length === 0) return

    fetch(this.reorderUrlValue, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "X-CSRF-Token": csrfToken(),
        "X-Requested-With": "XMLHttpRequest"
      },
      body: JSON.stringify({ ordered_ids: orderedIds })
    }).then((response) => {
      if (response.ok) {
        showToast("Gallery order saved")
      } else {
        this.revertOrder()
        showToast("Failed to save gallery order", "error")
      }
    }).catch(() => {
      this.revertOrder()
      showToast("Failed to save gallery order", "error")
    })
  }

  // Restore the pre-drag DOM order so the list never shows an order the server rejected.
  revertOrder() {
    if (!this.orderBeforeDrag) return

    this.orderBeforeDrag.forEach((row) => this.element.appendChild(row))
  }
}
